import { render, staticRenderFns } from "./TabDistribuicaoOperador.vue?vue&type=template&id=c5676a5e&"
import script from "./TabDistribuicaoOperador.vue?vue&type=script&lang=js&"
export * from "./TabDistribuicaoOperador.vue?vue&type=script&lang=js&"
import style0 from "./TabDistribuicaoOperador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports